module.exports = {"title":"Rastrear Pedido","paragraph":"Acompanhe seu pedido por aqui ou no aplicativo. Sua entrega chega em até 7 dias úteis.","ticket":"Pedido nº","textNotArrived":"Seu pedido ainda não chegou?","textActivateTagHelper":"Já recebeu o pedido?","buttonActivateTagHelper":"Ative sua VeloeTag agora!","buttonNotArrived":"Calma que te ajudamos..."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/FirstAccessFollowRequestDetail/data.json
// module id = 664
// module chunks = 0